import { css } from "emotion";

import { colors, fonts, icons } from "@cobliteam/base-components/src/styles";

export const flex = css`
  display: flex;
`;

export const valueWrap = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > :not(:first-child) {
    margin-left: 10px;
  }
`;

export const ulReset = css`
  padding: 0;
  margin: 0;
`;

export const iconWrap = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  & > svg {
    font-size: ${icons.size.small};
    color: ${colors.gray.default};
    height: 16px;
    width: 16px;
  }
`;

export const textWrap = css`
  display: flex;
  align-items: start;
  flex-direction: column;
`;

export const displayUnit = css`
  font-weight: ${fonts.weight.regular};
`;

export const title = css`
  margin-top: 10px;
`;

export const subTitle = css`
  margin-top: 5px;
`;

export const listItem = css`
  display: flex;
  flex-direction: column;
  &:not(:first-of-type) {
    margin-top: 45px;
  }
  .${iconWrap} {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background-color: ${colors.gray.lightest};
  }
  .${textWrap} {
    margin-left: 47px;
  }
`;

export const smallListItem = css`
  display: flex;
  margin: 20px 0;
  &:last-of-type {
    margin-bottom: 0;
  }
  .${iconWrap} {
    height: 16px;
    width: 16px;
    background-color: transparent;
  }
  .${textWrap} {
    margin-left: 31px;
  }
`;

export const firstLine = css`
  display: flex;
  align-items: center;
`;

export const iconTextContainer = css`
  display: flex;
  flex-direction: row;
`;

export const tooltip = css`
  margin-left: 10px;
`;
